"use strict";

var entriesDeepL = require("../.internal/entriesDeepL.js");

var objectDeep = require("../.internal/objectDeep.js");

var flatL = require("../Lazy/flatL.js");

var mapL = require("../Lazy/mapL.js");

var curry = require("./curry.js");

var go = require("./go.js");

function merge(...objs) {
  return go(objs, mapL(entriesDeepL), flatL, objectDeep);
}

module.exports = curry(merge);